module.exports = __webpack_public_path__ + "img/CR02E.c28f6ae0.png";